/**
 * Same-origin base path of the backend API. In deployed environments the
 * custom domain's route config forwards `/api/**` to the backend; locally
 * `ng serve` proxies it via `proxy.conf.json`.
 */
export const API_BASE_PATH = '/api';
